import { DateTime } from 'luxon'
import { eventTypes } from '@/helpers/event-helpers'

const graph = state => {
  return state.graph
}

const graphEvents = state => {
  return state.graphEvents || []
}

const graphAlerts = state => {
  return state.graphAlerts || []
}

const graphNoiseEvents = (state, getters) => {
  return getters.graphEvents.filter(graphEvent => graphEvent.eventClass === eventTypes.NOISE)
}

const noiseEventTimestamps = (state, getters) => {
  return getters.graphNoiseEvents.reduce((acc, event) => {
    const zoneId = event.activityZone.activityZoneID
    const start = DateTime.fromISO(event.localStartDateTime, { setZone: true }).set({ seconds: 0 }).toISO({ suppressMilliseconds: true })
    const end = event.localEndDateTime ? DateTime.fromISO(event.localEndDateTime, { setZone: true }).set({ seconds: 0 }).toISO({ suppressMilliseconds: true }) : null
    return {
      ...acc,
      [zoneId]: [
        start,
        ...(end ? [end] : []),
        ...(acc[zoneId] ? acc[zoneId] : [])],
    }
  }, {})
}

const graphDisconnectEvents = (state, getters) => {
  return getters.graphEvents.filter(graphEvent => graphEvent.eventClass === eventTypes.DISCONNECT)
}

const disconnectEventTimestamps = (state, getters) => {
  return getters.graphDisconnectEvents.reduce((acc, event) => {
    const zoneId = event.activityZone.activityZoneID
    const start = DateTime.fromISO(event.localStartDateTime, { setZone: true }).set({ seconds: 0 }).toISO({ suppressMilliseconds: true })
    const end = event.localEndDateTime ? DateTime.fromISO(event.localEndDateTime, { setZone: true }).set({ seconds: 0 }).toISO({ suppressMilliseconds: true }) : null
    return {
      ...acc,
      [zoneId]: [
        start,
        ...(end ? [end] : []),
        ...(acc[zoneId] ? acc[zoneId] : [])],
    }
  }, {})
}

const graphTooltipData = (state, getters) => {
  const eventTooltipItems = getters.graphEvents.map((event, id) => {
    return {
      id,
      tooltipType: 'event',
      type: event.eventClass,
      start: DateTime.fromISO(event.localStartDateTime, { setZone: true }).set({ seconds: 0 }).toISO({ suppressMilliseconds: true }),
      end: event.localEndDateTime ? DateTime.fromISO(event.localEndDateTime, { setZone: true }).set({ seconds: 0 }).toISO({ suppressMilliseconds: true }) : null,
      activityZone: event.activityZone?.activityZoneName,
    }
  })
  const alertTooltipItems = getters.graphAlerts.map((alertItem, id) => {
    return {
      id,
      tooltipType: 'alert',
      type: alertItem.alert_type,
      timestamp: alertItem.created_at,
      activityZone: alertItem.activity_zone_id,
    }
  })
  return { events: eventTooltipItems, alerts: alertTooltipItems }
}

const graphEventAnnotations = (state, getters) => {
  return getters.graphEvents.map((graphEvent, i) => {
    const isDisconnect = graphEvent.eventClass === eventTypes.DISCONNECT
    const setCursorStyle = (style) => { document.body.style.cursor = style }
    return {
      drawTime: 'beforeDatasetsDraw',
      type: 'box',
      event: graphEvent,
      id: `box-${i}`,
      xScaleID: 'x-axis-0',
      yScaleID: 'y-axis-0',
      xMin: DateTime.fromISO(graphEvent.localStartDateTime, { setZone: true }).set({ seconds: 0 }).toISO({ suppressMilliseconds: true }),
      xMax: graphEvent.localEndDateTime ? DateTime.fromISO(graphEvent.localEndDateTime, { setZone: true }).set({ seconds: 0 }).toISO({ suppressMilliseconds: true }) : null,
      yMin: 0,
      yMax: 100,
      borderColor: isDisconnect ? '#AEAEAE33' : '#50847B33',
      backgroundColor: isDisconnect ? '#AEAEAE33' : '#50847B33',
      borderWidth: 0.0,
      onMouseenter: function (e) {
        setCursorStyle('pointer')
        this.options.backgroundColor = isDisconnect ? '#AEAEAEAA' : '#50847BAA'
        this.chartInstance.update()
      },
      onMouseleave: function (e) {
        setCursorStyle('default')
        this.options.backgroundColor = isDisconnect ? '#AEAEAE33' : '#50847B33'
        this.chartInstance.update()
      },
      onMouseup: function (e) { setCursorStyle('default') },
  }
  })
}

const total = (state) => {
  return state.total
}

const savedThresholdSettings = (state) => {
  return state.savedThresholdSettings
}

const savedThresholdProfile = (state) => {
  return state.savedThresholdProfile
}

const propertyDetails = (state) => {
  return state.propertyDetails
}

export default {
  graph,
  graphEvents,
  graphAlerts,
  graphNoiseEvents,
  graphDisconnectEvents,
  graphTooltipData,
  noiseEventTimestamps,
  disconnectEventTimestamps,
  graphEventAnnotations,
  total,
  savedThresholdSettings,
  savedThresholdProfile,
  propertyDetails,
}
